import styled from 'styled-components';

export const AddGuestPlayerPopOverStyled = styled.div`
  .popover-button-button {
    height: var(--bigButtonHeight);

    .button__label {
      justify-content: flex-start;
      color: var(--mainColor);
    }
  }
`;
